import React from "react";
import Fade from "react-reveal/Fade";
import { css } from "emotion";
import ErbaFolder from "components/folder/Folder";

import Container from "components/shared/Container";
import styleConfig from "styles/styleConfig";

const { colors, margin, padding, borderRadius, boxShadow, transition } = styleConfig;

const productsWrapper = css`
  .content {
    display: flex;
    justify-content: center;
    align-items: center;
    .folder {
      margin-bottom: ${margin[4]};
      border: 1px solid ${colors.gray[100]};
      border-radius: ${borderRadius.md};
      padding: ${padding[4]};
      overflow: hidden;
      max-width: calc(620px + 2rem);
      box-shadow: ${boxShadow.sm};
      transition: ${transition.default};
      &:hover {
        box-shadow: ${boxShadow.lg};
      }
      .magnifier {
        border-radius: ${borderRadius.md};
        overflow: hidden !important;
        img {
          width: 100%;
          max-width: 500px;
        }
      }
    }
  }
`;

interface Props {}

const Folder: React.FC<Props> = () => {
  return (
    <div className={productsWrapper}>
      <Container className="container">
        <div className="content">
          <Fade bottom>
            <div className="folder">
              <ErbaFolder />
            </div>
          </Fade>
        </div>
      </Container>
    </div>
  );
};

export default Folder;
